// eslint-disable-next-line angular/factory-name
angular.
module("digiexam.gradingMatrix").
factory("GradingMatrixGrade", function gradingMatrixGradeService() {
	"use strict";

	function GradingMatrixGrade(data) {
		var defaults = {
			id: 0,
			title: "",
		};

		angular.extend(this, defaults);

		if (data) {
			angular.extend(this, data);
		}
	}

	return GradingMatrixGrade;
});
